<section id="LoginPage">
   <div class="login-form-container">
      <img
         src="/assets/Logo-VetCor.png"
         class="site-logo"
         alt="Vetcor Apps Login" />
      <div class="login-subtitle">
         <span class="subtitle-line"></span>
         <span class="subtitle-text">LTK Workspace</span>
         <span class="subtitle-line"></span>
      </div>
      <button
         type="button"
         [disabled]="submitting"
         class="login-button"
         (click)="logIn()">
         <span
            *ngIf="submitting"
            class="fa fa-spin fa-spinner login-spinner"></span>
         Sign in with Microsoft
      </button>
      <p class="login-hint">You&rsquo;ll be redirected to Microsoft to sign in.</p>
      <div
         *ngIf="notFound"
         class="alert alert-danger login-error">
         We couldn't find a Vetcor Apps account for your Microsoft login.
      </div>
   </div>
</section>
